import React from "react";

import { Override } from "@admin/utils/overrideType";
import Select from "@admin/components/Select";

type Props = {
    label?: string;
    name?: string;
    className?: { block?: string };
    prependEmptyOption?: boolean;
} & Override<
    React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>,
    {
        className?: { block?: string };
    }
>;

const CountrySelect: React.FC<Props> = ({ label = `Страна`, name = `country_id`, prependEmptyOption = true, ...props }) => {
    // @ts-ignore
    const { countries }: Record<number, string> = window.CMS;

    const options = Object.entries(countries)
        .map(([id, name]) => ({
            value: id as unknown as number,
            label: name as string,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : -1));

    return <Select label={label} options={options} name={name} prependEmptyOption={prependEmptyOption} {...props} />;
};

export default CountrySelect;
